/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

export const formatTime = (timestamp) => {
  if (!timestamp) return '??:??';
  
  try {
    // Handle time-only format like "09:30:00"
    if (typeof timestamp === 'string' && timestamp.match(/^\d{2}:\d{2}:\d{2}$/)) {
      return timestamp.substring(0, 5); // Return HH:MM
    }
    
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      return '??:??';
    }
    
    return date.toLocaleTimeString('de-DE', {
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (e) {
    return '??:??';
  }
};

export const formatDate = (timestamp) => {
  if (!timestamp) return null;
  
  try {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return null;
    
    return date.toLocaleDateString('de-DE', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch {
    return null;
  }
};

export const sortByDate = (items, dateField = 'date') => {
  return [...items].sort((a, b) => {
    const dateA = a[dateField] ? new Date(a[dateField]).getTime() : Infinity;
    const dateB = b[dateField] ? new Date(b[dateField]).getTime() : Infinity;
    return dateA - dateB;
  });
};

export const sortByStartTime = (items, startField = 'timeStart') => {
  return [...items].sort((a, b) => {
    const timeA = a[startField] ? parseTime(a[startField]) : Infinity;
    const timeB = b[startField] ? parseTime(b[startField]) : Infinity;
    return timeA - timeB;
  });
};

const parseTime = (timeStr) => {
  if (!timeStr) return Infinity;
  
  // Handle HH:MM:SS format
  if (typeof timeStr === 'string' && timeStr.match(/^\d{2}:\d{2}:\d{2}$/)) {
    const [hours, minutes] = timeStr.split(':').map(Number);
    return hours * 60 + minutes;
  }
  
  // Handle timestamp
  return new Date(timeStr).getTime();
};
